import "../../Assets/Scss/Breadcrumbs.scss";

const Breadcrumbs = () => {
    return (
        <span></span>
    )
}

      
export default Breadcrumbs;